(() => {
  function trigger(elem, eventType, data) {
    if (!elem) {
      return;
    }

    const event = new CustomEvent(eventType, {
      bubbles: true,
      composed: true,
      cancelable: false,
      detail: data,
    });

    elem.dispatchEvent(event);
  }

  function getTarget(e) {
    if (
      e.composedPath
      && e.composedPath()
      && e.composedPath()[0]
    ) {
      return e.composedPath()[0];
    }
    return e.target;
  }

  window.swinger = {
    ...window.swinger,
    eventHub: {
      trigger,
      getTarget,
    },
  };
})();
